import React, { Component } from "react";

import Form from '@rjsf/antd';
import validator from '@rjsf/validator-ajv8';
import { bucketSchema, bucketUiSchema, AddButton, RemoveButton } from "./BucketSchema";
// import { Loader, ErrorBannerMessage } from '@ttd/lingo';
import { Alert, Spin, Modal } from 'antd';

import PropTypes from 'prop-types';

class EditBucket extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    update_existing_bucket: PropTypes.func,
    show_error: PropTypes.bool.isRequired,
    error_message: PropTypes.string.isRequired,
    bucket: PropTypes.string.isRequired
  }

  constructor() {
    super();
    this.state = {
      formData: {},
      formState: {},
      saving: false
    };

    this.form = React.createRef();
    this.submit_form = this.submit_form.bind(this);
  }

  submit_form({ formData }) {
    this.setState({ saving: true }, () => {
      this.props.update_existing_bucket(formData);
    })

  }

  render() {
    return (
      <div>
        <h1>Edit Project</h1>
        {/* {this.state.saving &&
          <div>
            <Loader />
            <h3>Saving...</h3>
            </div>
          }

          {this.props.show_error &&
          <ErrorBannerMessage>
            {this.props.error_message}
          </ErrorBannerMessage>
          } */}
        {this.state.saving &&
          <div>
            {/* <Loader /> */}
            <Spin spinning={this.state.saving} fullscreen />

            <h3>Saving...</h3>
          </div>
        }

        {this.props.show_error &&
          <Modal
            open={this.props.show_error}>
            <Alert
              message={this.props.error_message}
              type="error"
              banner
            />
          </Modal>
        }

        <Form
          disabled={this.state.saving}
          schema={bucketSchema}
          uiSchema={bucketUiSchema}
          formData={this.props.bucket}
          ref={this.form}
          validator={validator}
          onSubmit={this.submit_form}
          templates={{ ButtonTemplates: { AddButton:AddButton, RemoveButton:RemoveButton } }} />

      </div>
    );
  }
}

export default EditBucket;
